import {Tooltip} from "@mui/material";
import React from "react";
import {MuiButton} from "./MuiButton";

const TooltipComponent = ({children, title, color = null, variant = null}) => {
    return (
        <Tooltip enterTouchDelay={5} title={<div dangerouslySetInnerHTML={{__html: title}}/>}>
            <MuiButton className={"buttonTooltip"} color={color} variant={variant}>
                {children}
            </MuiButton>
        </Tooltip>
    );
}

export default TooltipComponent;